import React from 'react';

interface Props {
  children: JSX.Element;
}
let overwriteHash: string | null = null;

export type OverwriteContextType = Record<string, string>;
export const OverwriteContext = React.createContext<OverwriteContextType>({});

const OVERWRITE_QUERY_STRING_KEY = 'overwriteRemote';
const OVERWRITE_CONFIG_HASH_KEY = 'oc';

export const DynamicRemoteOverwrite = ({ children }: Props): JSX.Element => {
  const queryParams = new URLSearchParams(window.location.search);

  const overwriteConfig: OverwriteContextType = getOverwriteConfig(queryParams);

  return (
    <OverwriteContext.Provider value={overwriteConfig}>
      {children}
    </OverwriteContext.Provider>
  );
};

function getOverwriteConfig(queryParams: URLSearchParams) {
  const overwriteConfig: OverwriteContextType = {};
  if (queryParams.has(OVERWRITE_QUERY_STRING_KEY)) {
    queryParams
      .getAll(OVERWRITE_QUERY_STRING_KEY)
      .forEach((overwriteString) => {
        const [scope, url] = overwriteString.split('|');
        overwriteConfig[scope] = url;
      });
    queryParams.delete(OVERWRITE_QUERY_STRING_KEY);
    console.log('Using Overwrite Config from Querystring', overwriteConfig);

    let hash = window.location.hash;
    if (overwriteConfig && Object.keys(overwriteConfig).length > 0) {
      const overwriteConfigString = btoa(JSON.stringify(overwriteConfig));
      overwriteHash = `${OVERWRITE_CONFIG_HASH_KEY}=${overwriteConfigString}`;
      if (hash.includes(OVERWRITE_CONFIG_HASH_KEY)) {
        const regex = new RegExp(
          `${OVERWRITE_CONFIG_HASH_KEY}=.*?(?=&|$)`,
          'g',
        );
        hash.replace(regex, overwriteHash);
      } else if (hash) {
        hash += `&${overwriteHash}`;
      } else {
        hash = overwriteHash;
      }
    }
    const historyState = window.history.state;
    window.history.replaceState(
      historyState,
      '',
      `${window.location.pathname}?${queryParams}${hash}`,
    );
  } else if (window.location.hash.includes(OVERWRITE_CONFIG_HASH_KEY)) {
    const hashParams = new URLSearchParams(
      window.location.hash.replace('#', ''),
    );
    const overwriteConfigString = hashParams.get(OVERWRITE_CONFIG_HASH_KEY);
    if (overwriteConfigString) {
      const overwriteConfigNew = JSON.parse(atob(overwriteConfigString));
      Object.keys(overwriteConfigNew).forEach((key) => {
        overwriteConfig[key] = overwriteConfigNew[key];
      });
      console.log('Using Overwrite Config from Hash', overwriteConfig);
    }
  }
  return overwriteConfig;
}
